export { Flex } from '@mantine/core'
